import { io, Socket } from 'socket.io-client'

/**
 * Socket.IO path that hosts the `/webchat` namespace.
 *
 * The runtime exposes two independent Socket.IO servers on the same HTTP server:
 * the notifications service on `/socket.io` (namespace `/admin/monitoring`) and the
 * main WebSocket service on `/ws` (namespace `/webchat`, see `backend/src/services/websocket.service.ts`).
 * Connecting the `/webchat` namespace through `/socket.io` fails with "Invalid namespace".
 */
export const WEBCHAT_SOCKET_PATH = '/ws'

export interface WebchatSocketAuth {
  widgetToken: string
  tenantSlug: string
  visitorId: string
}

export function createWebchatSocket(baseUrl: string, auth: WebchatSocketAuth): Socket {
  return io(`${baseUrl}/webchat`, {
    path: WEBCHAT_SOCKET_PATH,
    transports: ['websocket', 'polling'],
    auth,
  })
}
